import { h, Component } from 'preact';

import { configure } from '../../../../config';

import { Desktop } from './device/desktop.js';
import { Tablet } from './device/tablet.js';
import { Phone } from './device/phone.js';

import { COMMON_CONFIGS, setTheme } from '../../../../lib/page';
import { getPageConfig, getDeviceTemplate } from '../../../../lib/device';
import { trackPageLoad } from '../../../../lib/tracking';

import { trackingProvider, DIMENSION } from '@cube/track';
import { deviceVariance } from '@cube/blocks';

@trackingProvider({
	[DIMENSION.componentpath]: 'FinancePressPage'
})
@configure({
	...COMMON_CONFIGS,
	pageConfig: 'singleCube.pages.financePress'
})
@deviceVariance()
export default class FinancePress extends Component {

	componentWillMount() {
		let device = this.props.device,
			pageConfig = getPageConfig(this.props.pageConfig, device);
		this.setState({ pageConfig, Device: getDeviceTemplate({ device, Desktop, Tablet, Phone }) });

		setTheme(pageConfig);
	}

	componentDidMount() {
		trackPageLoad(this.context);
	}

	render( props, { Device, pageConfig }) {
		return (
			<Device
				{...props}
				pageConfig={pageConfig}
			/>
		);
	}
}
